import {
  CompanyUsersService,
  type PutCompanyUserAdminRequest,
  type PostCompanyUserBulkAdminRequest
} from '@/backend/market'
import { CompanyUsersRepository } from '../../domain/repositories/CompanyUsersRepository'
import { CompanyUsersModel } from '../models/CompanyUsersModel'
import { CompanyUsersFilterModel } from '../models/CompanyUsersFilterModel'
import { UpdateCompanyUserModel } from '../models/UpdateCompanyUserModel'
import { BulkCompanyUserModel } from '../models/BulkCompanyUserModel'
import type { CompanyUsersFilterEntity } from '../../domain/entities/CompanyUsersFilterEntity'
import type { UpdateCompanyUserEntity } from '../../domain/entities/UpdateCompanyUserEntity'
import type { CompanyUsersResponseEntity } from '../../domain/entities/CompanyUsersResponseEntity'
import type { BulkCompanyUserEntity } from '../../domain/entities/BulkCompanyUserEntity'
import type { CompanyUsersEntity } from '../../domain/entities/CompanyUsersEntity'

export class CompanyUsersRepositoryImpl implements CompanyUsersRepository {
  async getCompanyUsers(
    filterData: CompanyUsersFilterEntity
  ): Promise<CompanyUsersResponseEntity | { error: true }> {
    try {
      const companyUsersFilterModel = new CompanyUsersFilterModel(filterData)
      const response = await CompanyUsersService.getCompanyUsersAdmin(companyUsersFilterModel)
      const companyUserModels =
        response?.items?.map((companyUser) => new CompanyUsersModel(companyUser)) ?? []
      return {
        ...response,
        items: companyUserModels
      }
    } catch {
      return { error: true }
    }
  }

  async getCompanyUserById(id: number): Promise<CompanyUsersEntity | { error: true }> {
    try {
      const response = await CompanyUsersService.getCompanyUserAdmin({ id })
      const companyUserModel = new CompanyUsersModel(response)
      return companyUserModel
    } catch {
      return { error: true }
    }
  }

  async createCompanyUsers(
    data: BulkCompanyUserEntity
  ): Promise<{ success: true } | { error: true }> {
    try {
      const bulkCompanyUserModel = new BulkCompanyUserModel(data)
      await CompanyUsersService.postCompanyUserBulkAdmin({
        requestBody: bulkCompanyUserModel as PostCompanyUserBulkAdminRequest
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }

  async updateCompanyUser(
    id: number,
    data: UpdateCompanyUserEntity
  ): Promise<{ success: true } | { error: true }> {
    try {
      const updateCompanyUserModel = new UpdateCompanyUserModel(data)
      await CompanyUsersService.putCompanyUserAdmin({
        id,
        requestBody: updateCompanyUserModel as PutCompanyUserAdminRequest
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }

  async deleteCompanyUser(id: number): Promise<{ success: true } | { error: true }> {
    try {
      await CompanyUsersService.deleteCompanyUserAdmin({ id })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
}
